module.exports = __webpack_public_path__ + "../front/img/468_bøjestang+2hylder.c47f7f6f.svg";